import { siteExpirationNotification } from '../../zeus/SiteExpirationNotification';
import { AppState } from '../state/AppState';
import { InformationObject } from '../state/InlineBannerInfoState';

export function selectInlineBannerInfo(state: AppState): InformationObject {
    return siteExpirationNotification.showNotificationsIfEnabled();
}